import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4806684"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]

import { numberWithCommas } from '@/constants/common'
import { PropType, ref, nextTick, onMounted, watch } from 'vue'
import { CommentType } from '@/store/modules-community-admin/community-site'
import ArticleComment from '@/views/community-admin/community-site/components/ArticleComment.vue'
import { translate } from '@/languages/i18n'
import { ARTICLE_MODAL_ID } from '@/views/community-admin/community-site/constants'
import { Collapse } from 'bootstrap'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  comments: {
    type: Array as PropType<Array<CommentType>>,
    required: true,
    default: () => [],
  },
  postId: {
    type: Number,
  },
  comment_count: {
    type: Number,
  },
  fetchAllComment: {
    type: Function as PropType<() => void>,
    default: () => null,
  },
  modalId: {
    type: Object as PropType<string>,
    default: ARTICLE_MODAL_ID,
  },
},
  emits: ['showDeleteCommentModal', 'showUpdateCommentErrorModal', 'showCommentUserDetailInformation'],
  setup(__props, { expose, emit }) {

const props = __props

const COLLAPSE_AREA_TARGET_ID = 'flush-collapse'


const route = useRoute()

const isShowFullComment = ref<boolean>(false)
const idComment = ref<string>()

onMounted(() => {
  document.getElementById(ARTICLE_MODAL_ID).addEventListener('hidden.bs.modal', () => {
    isShowFullComment.value = false
  })
  const modalElement = document.getElementById(ARTICLE_MODAL_ID)
  if (modalElement) {
    modalElement.addEventListener('shown.bs.modal', () => {
      idComment.value = route.query?.target_content_id
      if (idComment.value) {
        nextTick(() => {
          const interval = setInterval(() => {
            if (props.comments.length > 0) {
              const isCommentIdLast = props.comments.slice(-1)[0]?.id == idComment.value
              clearInterval(interval)
              const collapseElement = document.getElementById(COLLAPSE_AREA_TARGET_ID)
              if (isCommentIdLast) {
                scrollToComment()
              } else if (collapseElement) {
                props?.fetchAllComment()
                isShowFullComment.value = true
                const bsCollapse = new Collapse(collapseElement, { toggle: false })
                bsCollapse.show()
              }
            }
          }, 200)
          setTimeout(() => {
            clearInterval(interval)
          }, 5000)
        })
      }
    })
  }
})

const scrollToComment = () => {
  const interval = setInterval(() => {
    const element = document.getElementById(idComment.value) as HTMLElement | null
    if (element && !stopScroll.value) {
      clearInterval(interval)
      stopScroll.value = true
      const modalPost = document.getElementById(ARTICLE_MODAL_ID)
      const elementPosition = element.getBoundingClientRect().top - 20
      modalPost?.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      })
      stopScroll.value = false
    }
  }, 100)
  setTimeout(() => {
    clearInterval(interval)
  }, 5000)
}

const stopScroll = ref(false)
watch(
  () => isShowFullComment.value,
  () => {
    if (isShowFullComment.value) {
      if (idComment.value && !stopScroll.value) {
        setTimeout(() => {
          scrollToComment()
        }, 300)
      }
    } else {
      stopScroll.value = false
    }
  }
)
const handleShowAllCommentClick = () => {
  props?.fetchAllComment()
  isShowFullComment.value = !isShowFullComment.value
}

const updateCommentListCollapseState = (isExpanded: boolean) => {
  isShowFullComment.value = isExpanded
}

const showDeleteCommentModal = (comment: CommentType) => {
  emit('showDeleteCommentModal', comment, isShowFullComment.value)
}

const updateCommentPublishedState = (comment, CommentType) => {
  emit('updateCommentPublishedState', comment)
}

const showCommentUserDetailInformation = (comment) => {
  emit('showCommentUserDetailInformation', comment)
}

expose({
  updateCommentListCollapseState,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.comment_count > 1)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "text-decoration-underline fs-75 cursor-pointer mb-4",
          "data-bs-toggle": "collapse",
          "data-bs-target": COLLAPSE_AREA_TARGET_ID,
          "aria-expanded": "false",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleShowAllCommentClick()))
        }, [
          _createTextVNode(_toDisplayString(_unref(translate)('CK12TotalNumberOfComment').replace('%s', _unref(numberWithCommas)(__props.comment_count - 1))) + " ", 1),
          _createElementVNode("i", {
            class: _normalizeClass(["fas fa-caret-down", [isShowFullComment.value ? 'rotate' : '']])
          }, null, 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: COLLAPSE_AREA_TARGET_ID,
      class: _normalizeClass(['accordion-collapse collapse', { show: isShowFullComment.value }]),
      "aria-labelledby": "flush-headingOne",
      "data-bs-parent": "#accordionFlushExample"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comments.slice(0, -1), (comment) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "user mb-3 d-flex",
          key: comment.id,
          id: comment.id
        }, [
          _createVNode(ArticleComment, {
            comment: comment,
            id_comment: idComment.value,
            onShowDeleteCommentModal: showDeleteCommentModal,
            onUpdateCommentPublishedState: updateCommentPublishedState,
            onShowCommentUserDetailInformation: showCommentUserDetailInformation
          }, null, 8, ["comment", "id_comment"])
        ], 8, _hoisted_1))
      }), 128))
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comments.slice(-1), (comment) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "border-bottom user mb-3 pb-3 d-flex",
        key: comment.id,
        id: comment.id
      }, [
        _createVNode(ArticleComment, {
          comment: comment,
          id_comment: idComment.value,
          onShowDeleteCommentModal: showDeleteCommentModal,
          onUpdateCommentPublishedState: updateCommentPublishedState,
          onShowCommentUserDetailInformation: showCommentUserDetailInformation
        }, null, 8, ["comment", "id_comment"])
      ], 8, _hoisted_2))
    }), 128))
  ], 64))
}
}

})